﻿import React, { createContext, useState, useMemo } from "react";
//import { FilterFacilities } from './partials/Filters'

export const initCityPageContext = {
  country: 'se', 
  showLoadingScreen: true, 
  customerService: false, 
  customerServiceDate: null, 
  selectedLocation: null, 
  returnToOriginalPosition: false, 
  lastKnownLocation: null, 
  filtersOpen: false, 
  filterSelection: {
    disabled: false,
    electricChargingPoint: false,
    indoor: false,
    outdoor: false,
    heated: false,
    maxVehicleHeight: false,
    LTP: false,
    STP: false,
  }, 
  mapViewOpen: false, 
  mapElementInDom: null, 
  mapPosition: null,
  mapZoom: 15,
  mapBounds: null, 
  updateMapBounds: false, 
  allFacilities: null,
  filteredFacilities: null,
  visibleFacilities: null,
  panOnLoad: true,
  focusedFacility: null,
  filterOnInit: false,
}

export const CityPageContext = createContext(null)

export const CityPageContextProvider = (props) => {
  const initContext = initCityPageContext;

  const [cityPageContext, setCityPageContextTmp] = useState(initContext)

  const setCityPageContext = (state) => {
    setCityPageContextTmp(state);
  }

  const cityPageState = useMemo(() => ({ cityPageContext, setCityPageContext }), [cityPageContext, setCityPageContext]);

  return (
    <CityPageContext.Provider value={cityPageState}>
      {props.children}
    </CityPageContext.Provider>
  )
}
